import { useTranslation } from 'react-i18next'
import { useNotices } from '../hooks/useNotices'

const DOT: Record<string, string> = {
  healthy: 'bg-green-500',
  degraded: 'bg-amber-500',
  down: 'bg-red-500',
  unknown: 'bg-neutral-400',
}

/** Avisos — what Argos thinks you should look at right now: unhealthy elements,
 *  the likely cause (latest deploy), and who's affected (blast radius). */
export function NoticesPage() {
  const { t } = useTranslation()
  const { data: notices = [], isLoading } = useNotices()

  return (
    <div>
      <h2 className="text-xl font-semibold">{t('notices.title')}</h2>
      <p className="mt-1 text-sm text-neutral-500">{t('notices.subtitle')}</p>

      {isLoading ? null : notices.length === 0 ? (
        <p className="mt-8 text-sm text-neutral-500">{t('notices.empty')}</p>
      ) : (
        <ul className="mt-4 flex flex-col gap-2">
          {notices.map((n) => (
            <li
              key={n.elementKey}
              className="rounded border border-neutral-200 bg-white p-3 dark:border-neutral-800 dark:bg-neutral-800"
            >
              <div className="flex items-center gap-2">
                <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${DOT[n.health] ?? DOT.unknown}`} aria-label={n.health} />
                <span className="font-medium">{n.name}</span>
                <span className="text-xs uppercase text-neutral-500">{n.health}</span>
              </div>
              <div className="mt-1 pl-[18px] text-xs text-neutral-500">
                {n.lastDeployAt && (
                  <span>{t('notices.lastDeploy')}: {new Date(n.lastDeployAt).toLocaleString()} </span>
                )}
                {n.affected.length > 0 && (
                  <span className="block">
                    {t('notices.affected', { count: n.affected.length })}: {n.affected.map((a) => a.name).join(', ')}
                  </span>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
